export default __webpack_public_path__ + "static/media/Rectangular-Duct.22a4ff09.jpg";